/**
 * User Profile Main Entry Point
 * Refactored into modules for better maintainability.
 */
import { initTabs } from './modules/tabs';
import { initModal } from './modules/modal';
import { initMessages } from './modules/messages';
import { initNotes } from './modules/notes';
import { initSaved } from './modules/saved';
import { initSecurity } from './modules/security';
import { initUI } from './modules/ui';

export const initProfile = () => {
    const profileNav = document.getElementById('profile-tabs-nav');
    if (!profileNav) return;

    // Config from WordPress localization
    const config = window.united_auth_obj || window.params || {};

    // 1. Core navigation & UI
    const navButtons = document.querySelectorAll('.profile-nav__btn');
    const tabPanels = document.querySelectorAll('.profile-tab-panel');
    
    initTabs(navButtons, tabPanels);
    initUI();
    initModal();

    // 2. Functional modules
    initMessages(config);
    initNotes(config);
    initSaved(config);
    initSecurity(config);

    console.log('Profile System initialized in modular mode.');
};
